import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline';
  icon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  icon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-sm font-bold tracking-wider uppercase transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:ring-offset-black';
  const variants = {
    primary: 'bg-yellow-400 text-black hover:bg-white hover:text-black border border-transparent',
    outline: 'bg-transparent text-white border border-white/20 hover:border-yellow-400 hover:text-yellow-400'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-134">
      {children}
      {icon && <ArrowRight className="ml-2 w-4 h-4" data-id="element-135" />}
    </button>;
}